module.exports = __webpack_public_path__ + "static/media/kit8.43041a18.jpg";